
define('text!views/notifications/dashboard.html',[],function () { return '\r\n<div class="profile-notifications-dashboard">\r\n\r\n\t<h3>Notifications</h3>\r\n\r\n\t<div class="profile-notifications-form js-profile-notifications-form">Form</div>\r\n\r\n</div>\r\n';});

